import { PROMPT_H, PROMPT_PLACEHOLDER, PROMPT_W, PROMPT_X, PROMPT_Y, promptIsEmpty, promptSnippet } from '../promptNode';

type Props = {
  prompt: string;
  selected: boolean;
  viewing: boolean;
  onSelect: () => void;
  onView: () => void;
};

export default function PromptNode({ prompt, selected, viewing, onSelect, onView }: Props) {
  const empty = promptIsEmpty(prompt);
  const snippet = empty ? PROMPT_PLACEHOLDER : promptSnippet(prompt);

  return (
    <div
      data-testid="prompt-node"
      onMouseDown={(e) => {
        e.stopPropagation();
        onSelect();
      }}
      className={`absolute rounded-2xl bg-surface border overflow-hidden transition-colors ${selected ? 'border-warning' : 'border-warning/40'}`}
      style={{
        left: PROMPT_X,
        top: PROMPT_Y,
        width: PROMPT_W,
        minHeight: PROMPT_H,
        boxShadow: selected ? '0 0 0 1px #FDCB6E55' : undefined,
      }}
    >
      <div className="flex items-center gap-2 px-3 pt-2.5">
        <div className="w-6 h-6 rounded-md flex items-center justify-center shrink-0 bg-warning/20 text-warning">
          <i className="ri-flag-2-fill text-sm" />
        </div>
        <div className="min-w-0">
          <div className="text-[13px] font-semibold text-textp">Outcome</div>
          <div className="text-[10px] text-texts leading-none mt-0.5">Prompt</div>
        </div>
      </div>
      <div className="px-3 pb-2.5 pt-1">
        <div className="text-[11px] leading-snug truncate text-texts">{snippet}</div>
        <button
          type="button"
          data-testid="prompt-node-view"
          aria-pressed={viewing}
          onClick={onView}
          onMouseDown={(e) => e.stopPropagation()}
          className={`mt-1.5 inline-flex items-center gap-1 text-[11px] font-medium px-1.5 py-0.5 rounded-md border ${viewing ? 'text-warning bg-warning/15 border-warning/40' : 'text-texts border-border hover:text-textp hover:border-warning/40'}`}
        >
          <i className={`${viewing ? 'ri-eye-off-line' : 'ri-eye-line'} text-xs`} />
          {viewing ? 'Hide' : 'View'}
        </button>
      </div>
      <div
        className="absolute -right-1.5 top-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-warning border-2 border-bg"
        title="Pipeline starts here"
      />
    </div>
  );
}
